import { render, staticRenderFns } from "./BarraCrud.vue?vue&type=template&id=5154cde4"
import script from "./BarraCrud.vue?vue&type=script&lang=js"
export * from "./BarraCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports